<template>
    <div class="hero mt-3 container py-3">

        <div class="row">
            <div class="col-12">
                <p class="c-link">-------------- More About Us</p>
            </div>
            <div class="col-12">
                <h1 class="d-none d-md-block"> We Offer Top-Quality Services <br>
                    Dedicated to your convenience and satisfaction.</h1>

                <p class="d-block d-md-none mb-4">We Offer Top-Quality Services <br>
                    Dedicated to your convenience and satisfaction.</p>
            </div>
            <div class="col-12 row my-5 d-none d-md-flex">
                <div class="col-0 col-md-6 d-none d-md-flex">
                    <img src="@/assets/NewLogo.png" alt="logo" class="w-100">
                </div>
                <div class="col">
                    <h2 class="font-weight-bold mb-4">Our History & Goal</h2>
                    <p>As a trusted tax service provider, we have been committed to delivering accurate, reliable, and
                        personalized solutions to our clients.</p>
                </div>
            </div>
            <div class="col-12">
                <carousel :per-page="1" :navigate-to="someLocalProperty" :mouse-drag="false" autoplay="true"
                    loop="true">
                    <slide>

                        <!-- <img src="@/assets/hero.png" alt="team" class="w-100"> -->
                        <div class="itr-image p-4 ">
                            <h2 class="text-white">ITR filing starts at</h2>
                            <div class="d-flex">
                                <h2 style="font-size:85px; " class="font-weight-bold text-white">₹499

                                </h2>
                                <div style="font-size: 60px;" class="text-white">*</div>
                            </div>
                        </div>
                    </slide>
                    <slide>
                        <div class="gst-image p-4 ">
                            <h2 class="font-white">GST filing starts at</h2>
                            <div class="d-flex">
                                <h2 style="font-size:85px; " class="font-weight-bold text-white">₹599

                                </h2>
                                <div style="font-size: 60px;" class="text-white">*</div>
                            </div>
                        </div>
                    </slide>
                    <slide>
                        <div class="tds-image p-4 ">
                            <h2 class="text-white">TDS filing starts at</h2>
                            <div class="d-flex">
                                <h2 style="font-size:85px; " class="font-weight-bold text-white">₹999

                                </h2>
                                <div style="font-size: 60px;" class="text-white">*</div>
                            </div>

                        </div>
                    </slide>
                </carousel>
            </div>

        </div>
    </div>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel';
export default {
    name: 'heroComponent',
    components: {
        Carousel,
        Slide
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.gst-image {
    background-image: url("@/assets/gst_.jpeg");
    background-size: cover;
    background-position: center;
    height: 600px;

    @media screen and (max-width: 480px) {
        height: 350px !important;
    }
}

.itr-image {
    background-image: url("@/assets/itr.png");
    background-size: cover;
    background-position: center;
    height: 600px;

    @media screen and (max-width: 480px) {
        height: 350px !important;
    }
}

.tds-image {
    background-image: linear-gradient(to bottom right, #0000006a, #ffffff43), url("@/assets/tds_.png");
    background-size: cover;
    background-position: center;
    height: 600px;

    @media screen and (max-width: 480px) {
        height: 350px !important;
    }
}

.hero {
    /* background-color: #fcf2e875; */
    border-radius: 12px;
}
</style>